import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { StepsModule } from 'primeng/steps';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService, MenuItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

import { NGXLogger } from 'ngx-logger';
import { RichiesteService } from '../../../services/richieste.service';
import { Richiesta } from '../../../models/richiesta.model';
import { StiliService } from '../../../services/stili.service';
import { SchedeService } from '../../../services/schede.service';
import { Scheda } from '../../../models/scheda.model';
import { MappaSchedaNuovoInterventoComponent } from '../nuovo-intervento/mappa-scheda-nuovo-intervento.component';
import { InterventiService } from '../../../services/interventi.service';
import { TipoIntervento } from '../../../models/tipo-intervento.model';
import { Intervento } from '../../../models/intervento.model';

@Component({
  selector: 'app-modifica-intervento',
  templateUrl: './modifica-intervento.component.html',
  styleUrls: ['./modifica-intervento.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    InputNumberModule,
    StepsModule,
    ToastModule,
    TooltipModule,

  ],
  providers: [DialogService, MessageService]
})
export class ModificaInterventoComponent implements OnInit {
  @Input() isEnteEsecutore: boolean = false;
  @Input() intervento: Intervento | null = null;
  @ViewChild(MappaSchedaNuovoInterventoComponent) mappaSchedaNuovoInterventoComponent!: MappaSchedaNuovoInterventoComponent;
  @Output() interventoModificato = new EventEmitter<Intervento>();

  private fb = inject(FormBuilder);
  private schedaService = inject(SchedeService);
  private interventoService = inject(InterventiService);
  private richiesteService = inject(RichiesteService);
  private messageService = inject(MessageService);
  stiliService = inject(StiliService);
  private dialogService = inject(DialogService);

  form!: FormGroup;
  activeIndex = 0;
  visible = false;
  submitting = false;
  enteId: string | null = null;



  tipiIntervento: TipoIntervento[] = [];
  statiIntervento: any[] = [];
  priorita = [
    { label: 'Alta', value: 1 },
    { label: 'Media', value: 2 },
    { label: 'Bassa', value: 3 },
  ];

  constructor(
    private logger: NGXLogger
  ) {
    this.initForm();
  }

  private initForm(): void {
    this.form = this.fb.group({
      tipoIntervento: [null, Validators.required],
      priorita: [this.priorita[0], Validators.required],
      importoRichiesto: [this.intervento?.importoRichiesto, [Validators.required, Validators.min(0)]],
      note: [this.intervento?.note]
    });
  }

  show(intervento: Intervento): void {
    this.intervento = intervento;
    this.visible = true;
    this.enteId = localStorage.getItem("enteId") || '';
    if(this.isEnteEsecutore){
      this.logger.info('[MODIFICA INTERVENTO] SONO UMVS!');
    }else{
      this.logger.info('[MODIFICA INTERVENTO] SONO ENTE ESECUTORE! Ente ID: ' + this.enteId);
    }
    this.caricaTipiIntervento();
    this.initForm();

  }

  hide(): void {
    this.visible = false;
    this.form.reset();
    this.activeIndex = 0;
  }


  ngOnInit(): void {

  }





  caricaTipiIntervento(): void {
    this.interventoService.getTipiIntervento().subscribe({
      next: (data) => {
        this.tipiIntervento = data;
        this.logger.info('[MODIFICA INTERVENTO] Tipi di intervento', this.tipiIntervento);
        // Preseleziona il primo elemento della lista
        if (this.tipiIntervento && this.tipiIntervento.length > 0) {
          this.logger.info('[MODIFICA INTERVENTO] Tipi di intervento', this.intervento?.tipoIntervento?.codice);
          this.form.get('tipoIntervento')?.setValue(this.tipiIntervento.find(t => t.codice === this.intervento?.tipoIntervento?.codice));
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore nel caricamento dei tipi di intervento'
        });
      }
    });
  }

  reset() {
    this.form.reset();
    this.intervento = null;
    this.enteId = null;
    this.isEnteEsecutore = false;
  }

  salvaModifiche(): void {
    if (this.form.valid && this.intervento) {
      this.submitting = true;
      let interventoModificato: Intervento  = this.intervento;
      interventoModificato.tipoIntervento   = this.form.get('tipoIntervento')?.value;
      //interventoModificato.priorita         = this.form.get('priorita')?.value;
      interventoModificato.priorita       = this.form.value.priorita.value;
      interventoModificato.importoRichiesto = this.form.get('importoRichiesto')?.value;
      // Assicura che il campo note sia sempre presente, anche se vuoto (null anziché undefined)
      const noteValue = this.form.get('note')?.value;
      interventoModificato.note = noteValue?.trim() || null;
      this.interventoService.modifica(interventoModificato).subscribe({
        next: () => {

          this.interventoModificato.emit(interventoModificato);
          this.reset();
          this.hide();
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Errore nella modifica dell\'intervento'
          });
        },
        complete: () => {
          this.submitting = false;
        }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Compila tutti i campi obbligatori'
      });
    }
  }



  isFormValid(): boolean {
    return this.form.valid;
  }


}
